import { jsx as _jsx } from "react/jsx-runtime";
const IndeterminateCheckIcon = ({ ...props }) => (_jsx("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: _jsx("rect", { x: "5", y: "9", width: "10", height: "2", fill: "currentColor" }) }));
export default IndeterminateCheckIcon;
